module.exports = __webpack_public_path__ + "assets/img/g3.7e1655e5.png";